import React from 'react';
import { Link } from 'react-router-dom';
import { Box } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import './AppFooter.styles.scss';
import Logo from '../../../components/Logo/Logo.component';
import useTranslation from '../../../translations/use-translation';

const footerSx = { backgroundColor: 'background.footer' };

const AppFooter = () => {
  const translate = useTranslation();

  return (
    <Box component="footer" className="footer-container" sx={footerSx}>
      <div className="footer-accent-bar" />

      <div className="footer-main">
        {/* Brand column */}
        <div className="footer-brand">
          <Link to="/" className="footer-brand-logo">
            <Logo />
          </Link>
          <Link to="/" className="footer-brand-name">{translate('ONLINE_APPLICATIONS')}</Link>
          <p className="footer-tagline">{translate('FOOTER_TAGLINE')}</p>
          <div className="footer-address">
            <LocationOnOutlinedIcon className="footer-address-icon" fontSize="small" />
            <div className="footer-address-lines">
              <span>{translate('ADDRESS_LINE_1')}</span>
              <span>{translate('ADDRESS_LINE_2')}</span>
            </div>
          </div>
          <div className="footer-social">
            <a href="#" className="footer-social-btn" aria-label="Facebook">
              <FacebookIcon fontSize="small" />
            </a>
            <a href="#" className="footer-social-btn" aria-label="Twitter">
              <TwitterIcon fontSize="small" />
            </a>
            <a href="#" className="footer-social-btn" aria-label="LinkedIn">
              <LinkedInIcon fontSize="small" />
            </a>
            <a href="#" className="footer-social-btn" aria-label="YouTube">
              <YouTubeIcon fontSize="small" />
            </a>
          </div>
        </div>

        {/* Products column */}
        <div className="footer-col">
          <h3 className="footer-col-title">{translate('PRODUCTS')}</h3>
          <ul className="footer-col-list">
            <li><a href="#">{translate('GOVT_EXAM_FORMS')}</a></li>
            <li><Link to="/services">{translate('ONLINE_SERVICES')}</Link></li>
            <li><a href="#">{translate('PAN_AADHAR')}</a></li>
          </ul>
        </div>

        {/* Quick Links column */}
        <div className="footer-col">
          <h3 className="footer-col-title">{translate('QUICK_LINKS')}</h3>
          <ul className="footer-col-list">
            <li><Link to="/track-applications">{translate('APPLICATION_STATUS')}</Link></li>
            <li><Link to="/services">{translate('SERVICES')}</Link></li>
            <li><Link to="/about-us">{translate('FOOTER_ABOUT')}</Link></li>
            <li><Link to="/contact-us">{translate('FOOTER_CONTACT_LINK')}</Link></li>
          </ul>
        </div>

        {/* Get In Touch column */}
        <div className="footer-col footer-col--contact">
          <h3 className="footer-col-title">{translate('FOOTER_GET_IN_TOUCH')}</h3>
          <p className="footer-contact-desc">{translate('FOOTER_CONTACT_DESC')}</p>
          <a
            href={`mailto:${translate('FOOTER_CONTACT_EMAIL')}`}
            className="footer-email-link"
          >
            <EmailOutlinedIcon fontSize="small" />
            <span>{translate('FOOTER_CONTACT_EMAIL')}</span>
          </a>
          <Link to="/contact-us" className="footer-cta-btn">
            {translate('FOOTER_CONTACT_CTA')}
            <ArrowForwardIcon fontSize="small" className="footer-cta-icon" />
          </Link>
        </div>
      </div>

      <div className="footer-divider" />

      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <p className="footer-copyright">{translate('FOOTER_COPYRIGHT')}</p>
          <div className="footer-bottom-links">
            <a href="#">{translate('FOOTER_PRIVACY')}</a>
            <span className="footer-bottom-sep" aria-hidden="true">·</span>
            <a href="#">{translate('FOOTER_TERMS')}</a>
          </div>
        </div>
      </div>
    </Box>
  );
};

export default AppFooter;
